import "./style.less";

export default function BookingCompleteController(
    user,
    $scope,
    $rootScope,
    $timeout,
    Basket,
    Bookings,
    CheckoutErrors,
    ENV
) {
    $scope.bookingError = { error: false };

    const allowedRoles = [72];

    if (allowedRoles.indexOf(user.primaryRole) == -1 && ENV.payment.enabled) {
        $scope.bookingError = CheckoutErrors.getBookingError({
            error: true,
            type: "not-allowed-user-role",
        });
    }

    const bookingId = Basket.getBookingId();

    if (!bookingId) {
        $scope.bookingError = CheckoutErrors.getBookingError({
            error: true,
            type: "no-booking-id-in-basket",
        });
    }

    Bookings.get(bookingId).then(
        (res) => {
            let booking = res;

            if (!booking.bookingPeriods.length) {
                $scope.bookingError = CheckoutErrors.getBookingError({
                    error: true,
                    type: "booking-expired",
                });
            }

            const lastBp =
                booking.bookingPeriods[booking.bookingPeriods.length - 1];

            const bpsToDisplay = booking.bookingPeriods.filter(
                (bp) => bp.completedOn == lastBp.completedOn
            );

            $scope.booking = booking;
            $scope.bpsToDisplay = bpsToDisplay;
            $rootScope.$broadcast("booking-update-broadcast");
        },
        (err) => {
            console.warn(err);
        }
    );

    $timeout(() => {
        Basket.resetBasket();
    });
}
